import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import plugins from './plugins';

import { parseQueryString } from '@sbvr/common/legacy-shared/helpers/url-helper';

const queryString = parseQueryString();

Vue.use(Vuex);

const store: Store<any> = new Vuex.Store({
  state: {
    auth: {
      token:
        queryString.token ||
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9mZWF0dXJlLW1kbS1kZXZpY2VzLWdyb3Vwcy1hcGkucmV2aWV3LnNwcmluZ2JvYXJkdnIuY29tXC9ncmFwaHFsIiwiaWF0IjoxNTc2MTM0NzUzLCJleHAiOjE2MDc2NzA3NTMsIm5iZiI6MTU3NjEzNDc1MywianRpIjoiOE00VnhndUk0M2pkc3FTMiIsInN1YiI6NDUsInBydiI6ImRhMjMyYzgyNmI0YWEzZTMxNGM2YWQ2NjRlOGMwZTA4NWMxMzRhNjEifQ.qcd-Gzv3a5Oo3eOYcVDXQNX1mpVTlxlhbCVEKXY2QjI',
    },
  },
  plugins,
});

export function useStore (): Store<any> {
  return store;
}

export default store;
